<template>
	<AppDialog ref="dialog_container" dialogName="AddEmailDomainDialog" width="500px">
		<div class="add-email-domain-dialog">
			<span class="dialog-title flex-centerize">Add a new email sending domain</span>
			<div class="font-size-lg font-weight-500">Domain name</div>
			<AppTextField v-model="domainName" outlined hide-details placeholder="example.com" />
			<Row class="font-size-lg font-weight-500">
				Return path name <span class="optional px-1"> (optional) </span>
				<AppTooltip
					position="bottom"
					text="The Return-Path is the address where bounces and other email feedback are sent. It is specified by the Return-Path header in an email."
				>
					<AppIcon name="question-mark-small"></AppIcon>
				</AppTooltip> </Row
			><Row>
				<AppTextField class="return-path-name-box" v-model="returnPathName" outlined hide-details placeholder="pm.mtasv.net" />
				<Row class="domain-name-suffix ml-1"> {{ domainNameSuffix }}</Row>
			</Row>
			<Row class="flex-centerize mb-4 mt-8">
				<PrimaryButton class="next-btn" :disabled="isNextDisabled" @click="addDomainClicked">Next</PrimaryButton>
			</Row>
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

function CheckIsValidDomain(domain) {
	const re = new RegExp(/^((?:(?:(?:\w[.\-+]?)*)\w)+)((?:(?:(?:\w[.\-+]?){0,62})\w)+)\.(\w{2,6})$/);
	return domain.match(re);
}

export default {
	name: 'AddEmailDomainDialog',
	components: { AppDialog },
	props: { dialogPromiseHandlers: { type: Object } },
	computed: {
		trimmedDomainName() {
			return this.domainName.trim();
		},
		trimmedReturnPathName() {
			return this.returnPathName.trim();
		},
		isNextDisabled() {
			return !CheckIsValidDomain(this.trimmedDomainName);
		},
		domainNameSuffix() {
			return '.' + this.trimmedDomainName;
		},
	},
	methods: {
		close() {
			AppDialogManagerService.closeCurrentDialog();
		},
		addDomainClicked() {
			const returnPathName = this.trimmedReturnPathName ? `${this.trimmedReturnPathName}.${this.trimmedDomainName}` : null;
			this.dialogPromiseHandlers.resolve({ domainName: this.trimmedDomainName, returnPathName });
			this.close();
		},
	},
	data() {
		return {
			domainName: '',
			returnPathName: '',
			allowedEmails: '',
		};
	},
};
</script>

<style scoped lang="scss">
.dot {
	font-size: 150%;
}
.domain-name-suffix {
	font-size: 16px;
	align-items: center;
	text-align: center;
	vertical-align: middle;
	margin-left: 0px;
}
.return-path-name-box {
	max-width: 190px;
}
.next-btn {
	min-width: 100px !important;
}
.optional {
	color: #7c7c7c;
	font-size: 14px;
	font-weight: 400;
	line-height: 22px;
}
.add-email-domain-dialog {
	border-radius: 15px !important;
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16) !important;
	padding: 20px 30px 14px 30px;

	::v-deep(.widget-preview) {
		min-height: 350px !important;
	}
}
</style>
